// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"adda4b38","198":"69a9d019","787":"19c21557"}[chunkId] + ".chunk.js";
};